import DriverCashTransactions from "../../../views/DriverCashTransactions";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const driverCashTransactionsRoutes = [
  {
    menuName: MenuNames.DRIVER_CASH_TRANSACTIONS,
    path: "/driver-cash-transactions",
    component: DriverCashTransactions,
    exact: true,
  },
];

export default driverCashTransactionsRoutes;
